import React, { Fragment } from 'react';
import { Button, Container, Row, Col } from "reactstrap";
import { Navigate, useNavigate } from 'react-router-dom';
import { DateConstants } from '../../../constants/date';
import { SolutionConstants } from '../../../constants/solution';
import ContractorProfile from '../../Project/assets/contractor-profile.jpg';
import ArrowRightSeaShell from '../../Project/assets/arrow-right-seashell.svg';
import MapPin from '../../Project/assets/map-pin.svg';
import CalendarBlank from '../../Project/assets/calendar-blank.svg';
import Email from '../../Project/assets/email.svg';
import House from '../../Project/assets/house.svg';
import CellPhone from '../../Project/assets/cell-phone.svg'
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import '../solution.scss';

function AssignedSolutionResponsive({solutions, loading, onContractorAccept, onContractorDecline}) {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress } = useMsal();
    const navigate = useNavigate();

    const handleContractorAccept = (solutionId) => {
        if (typeof onContractorAccept === 'function') {
            onContractorAccept(solutionId);
        }
    }

    const handleContractorDecline = (solutionId) => {
        if (typeof onContractorDecline === 'function') {
            onContractorDecline(solutionId);
        }
    }

    const handleSolutionView = (id) => {
        navigate("/my-work/" + id)
    }

    const ActionButtons = ({ solutionId }) => {
        return (
            <Fragment>
                <div className='row'>
                    <div className='col py-1'>
                        <Button
                            color='success'
                            onClick={() => { handleContractorAccept(solutionId) }}
                            className='w-100'
                        >
                            Accept
                        </Button>
                    </div>
                    <div className='col py-1'>
                        <Button
                            color='danger'
                            onClick={() => { handleContractorDecline(solutionId) }}
                            className='w-100'
                        >
                            Decline
                        </Button>
                    </div>
                </div>
            </Fragment>
        )
    }

    const showHomeownerData = (state) => {
        return state === SolutionConstants.STATE.CONTRACTOR_CONFIRMED
            || state === SolutionConstants.STATE.CONTRACT_CREATED;
    }

    return isAuthenticated ? (
        <div className='responsive contractor'>
            <Row>
                <Col md="2">
                    <span className="project-list-title">My work in progress</span>
                </Col>
            </Row>
            {
                solutions && solutions.length > 0 && solutions.map((solution) => {
                    let phone = solution.homeowner?.phone;
                    return (
                        <div key={solution.id}>
                            <Row className={'project-list-card mt-4'}>
                                <Col sm="12" className='h-100'>
                                    <div className='carousel-card carousel-item active'>
                                        <Container className='h-100'>
                                            <Row className='h-100 fs-4'>
                                                <Col md="1" className='w-75'>
                                                    <div className='mt-3 status-badge-container'>
                                                        <div className='text-uppercase'>
                                                            <span className={`badge ${solution.stateAssignment.state.code}`}>
                                                                {solution.stateAssignment.state.name}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='mt-0 h-50'>
                                                        <Row className='h-25'>
                                                        {
                                                            solution.stateAssignment.state.code === SolutionConstants.STATE.CONTRACTOR_ASSIGNED &&
                                                            <ActionButtons solutionId={solution.id}/>
                                                        }
                                                        {
                                                            showHomeownerData(solution.stateAssignment.state.code) &&
                                                            <Row>
                                                                <div className='project-details'>
                                                                    <div className='m-0 w-100 detail-row'>
                                                                        <img className='detail-image' src={House} alt="" />
                                                                        <span className='detail-text'>
                                                                            {`${solution.homeowner?.firstName} ${solution.homeowner?.lastName}`}
                                                                        </span>
                                                                    </div>
                                                                    <div className='m-0 w-100 detail-row'>
                                                                        <img className='detail-image' src={Email} alt="" />
                                                                        <span className='detail-text'>
                                                                            <a className='email' href={`mailto: ${solution.homeowner?.email}`}>
                                                                                {solution.homeowner?.email}
                                                                            </a>
                                                                        </span>
                                                                    </div>
                                                                            {
                                                                                phone &&
                                                                                <div className='m-0 w-100 detail-row'>
                                                                                    <img className='detail-image' src={CellPhone} alt="" />
                                                                                    <span className='detail-text'>
                                                                                        {`${phone}`}
                                                                                    </span>
                                                                                </div>
                                                                            }
                                                                </div>
                                                            </Row>
                                                        }
                                                        </Row>
                                                        <Row className={`mt-${phone ? 5 : 4} h-50`}>
                                                            <Col>
                                                                <p className='project-name mb-0'>{solution.projects[0]?.description}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row className='h-50'>
                                                            <div className='project-details'>
                                                                <div className='m-0 w-100 detail-row'>
                                                                    <img className='detail-image' src={MapPin} alt="" />
                                                                    <span className='detail-text'>
                                                                        {`${solution.location?.postalCode}, ${solution.location?.locality}, ${solution.location?.administrativeAreaName}`}
                                                                    </span>
                                                                </div>
                                                                <div className='m-0 w-100 detail-row'>
                                                                    <img className='detail-image' src={CalendarBlank} alt="" />
                                                                    <span className='detail-text'>
                                                                        {`Created on ${DateConstants.MONTHS[new Date(Date.parse(solution.createdAt)).getMonth()]} ${new Date(Date.parse(solution.createdAt)).getDate()}`}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </Row>
                                                    </div>

                                                </Col>
                                                <Col md="1" className='w-25'>
                                                    <Row className='h-50'>
                                                        <Col className='gx-0 text-end contractor-profile'>
                                                            <img className='mt-3' src={ContractorProfile} alt="Contractor" />
                                                        </Col>
                                                    </Row>
                                                    <Row className='h-50'>
                                                        <Col className='gx-0 right-arrow'>
                                                            <div className='h-100 d-flex align-items-end'>
                                                                <div className='w-100 text-end'>
                                                                    <Button onClick={() => handleSolutionView(solution.id)} color='link p-0 mb-3'>
                                                                        <img src={ArrowRightSeaShell} alt='' />
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )
                })
            }
            {
                !loading && solutions && solutions.length === 0 &&
                <Row className="mt-5 w-100 position-absolute">
                    <Col className="text-center">
                        <span className="project-list-title text-black">You don´t have work in progress yet</span>
                    </Col>
                </Row>
            }
        </div>
    ) : (inProgress === InteractionStatus.None ? (
        <Navigate to="/auth/login" />
    ) :
        ''
    );
}

export default AssignedSolutionResponsive;